'use client';

import { useTranslations } from 'next-intl';

import ArrowIcon from '@/fo/icons/base/icons/arrow24.svg';
import { UiArticleTileBase } from '@/fo/ui/article/tile/base';
import { UiKitButtonBase } from '@/fo/ui/kit/button/base';
import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';

import { ArticleItem } from '../types';

import { styles } from './UiArticleSectionImportant.styles';

export interface UiArticleSectionImportantProps {
  title?: string;
  hrefAll?: string;
  allLabel?: string;
  articles: ArticleItem[];
  className?: string;
  showAllText?: string;
  advertisingWarningText?: string;
}

export function UiArticleSectionImportant({
  title,
  hrefAll,
  articles,
  className,
  showAllText,
  advertisingWarningText
}: UiArticleSectionImportantProps) {
  const t = useTranslations();
  const slots = styles();

  return (
    <div className={slots.base({ className })}>
      {title && (
        <div className={slots.header()}>
          <h2 className={slots.title()}>{title}</h2>
          {hrefAll && (
            <UiKitButtonBase
              className={slots.link()}
              childrenClassName={slots.linkContent()}
              color="ghost"
              as="link"
              href={hrefAll || '/blog'}
            >
              {showAllText || t('linkAllArticle')}
              <ArrowIcon />
            </UiKitButtonBase>
          )}
        </div>
      )}
      <UiKitCarouselBase
        className={slots.list()}
        showArrows={false}
        arrowPrevClass="top-1/2 -translate-y-1/2 -left-5 right-auto size-10"
        arrowNextClass="top-1/2 -translate-y-1/2 -right-5 left-auto size-10"
      >
        {articles.map((item, index) => (
          <UiArticleTileBase
            className={slots.item()}
            key={index}
            article={item}
            advertisingWarningText={advertisingWarningText}
          />
        ))}
      </UiKitCarouselBase>
    </div>
  );
}
